import type { CompanyViewModel } from 'ab-viewModels/company.viewModel';

export class ShiftSettingsFM {
	timeBetweenShifts: number;
	maximumShiftDurationBeforeBreak1: number;
	maximumShiftDurationBeforeBreak2: number;
	minimumBreakDuration: number;

	constructor(
		timeBetweenShifts: number,
		maximumShiftDurationBeforeBreak1: number,
		maximumShiftDurationBeforeBreak2: number,
		minimumBreakDuration: number
	) {
		this.timeBetweenShifts = timeBetweenShifts;
		this.maximumShiftDurationBeforeBreak1 = maximumShiftDurationBeforeBreak1;
		this.maximumShiftDurationBeforeBreak2 = maximumShiftDurationBeforeBreak2;
		this.minimumBreakDuration = minimumBreakDuration;
	}

	static toRM(form: ShiftSettingsFM) {
		return {
			timeBetweenShifts: form.timeBetweenShifts,
			maximumShiftDurationBeforeBreak1: form.maximumShiftDurationBeforeBreak1 * 60,
			maximumShiftDurationBeforeBreak2: form.maximumShiftDurationBeforeBreak2 * 60,
			minimumBreakDuration: form.minimumBreakDuration,
		};
	}

	static fromVM(viewModel: CompanyViewModel) {
		return {
			timeBetweenShifts: viewModel.timeBetweenShifts,
			maximumShiftDurationBeforeBreak1: viewModel.maximumShiftDurationBeforeBreak1 / 60,
			maximumShiftDurationBeforeBreak2: viewModel.maximumShiftDurationBeforeBreak2 / 60,
			minimumBreakDuration: viewModel.minimumBreakDuration,
		};
	}
}

export const validate = (values: ShiftSettingsFM) => {
	const errors: ValidationErrors = {};

	if (!values.timeBetweenShifts) {
		errors.timeBetweenShifts = 'Time between shifts is required.';
	}

	if (!values.maximumShiftDurationBeforeBreak1) {
		errors.maximumShiftDurationBeforeBreak1 = 'Maximum shift duration before the first break is required.';
	}

	if (!values.maximumShiftDurationBeforeBreak2) {
		errors.maximumShiftDurationBeforeBreak2 = 'Maximum shift duration before the second break is required.';
	}

	if (!values.minimumBreakDuration) {
		errors.minimumBreakDuration = 'Minimum break duration is required.';
	}

	return errors;
};
